import React from 'react';
import { SectionReveal } from '../SectionReveal';
import { PriceBlock } from '../PriceBlock';
import { VALUE_ROWS, VALUE_TOTAL, PRICE_TODAY } from '../../data/content';
export function ValueTable() {
  return <section className="w-full bg-carbon" aria-labelledby="value-heading" data-id="element-199">
      <SectionReveal className="mx-auto w-full max-w-2xl px-5 py-16 sm:py-20" data-id="element-200">
        <h2 id="value-heading" className="mb-8 text-center font-heading text-2xl font-bold uppercase tracking-tight text-soft sm:text-3xl" data-id="element-201">
          📦 Tu Megapack completo
        </h2>

        <div className="overflow-hidden rounded-lg border border-gold-tenue" data-id="element-202">
          {/* Header row */}
          <div className="flex items-center justify-between gap-3 bg-orange px-5 py-3 text-white" data-id="element-203">
            <span className="font-heading text-sm font-bold uppercase" data-id="element-204">
              Lo que recibís
            </span>
            <span className="font-heading text-sm font-bold uppercase" data-id="element-205">
              Valor
            </span>
          </div>

          {/* Item rows */}
          <ul data-id="element-206">
            {VALUE_ROWS.map((row, i) => <li key={row.label} className={`flex items-center justify-between gap-4 px-5 py-3.5 ${i % 2 === 0 ? 'bg-carbon-2' : 'bg-carbon-3'}`} data-id="element-207">
                <span className="min-w-0 break-words text-sm text-soft" data-id="element-208">
                  {row.label}
                </span>
                <span className="flex-none text-sm text-muted" data-id="element-209">
                  {row.value}
                </span>
              </li>)}
          </ul>

          {/* Total */}
          <div className="flex items-center justify-between gap-4 border-t border-gold bg-carbon-3 px-5 py-4" data-id="element-210">
            <span className="font-heading text-sm font-extrabold uppercase text-gold" data-id="element-211">
              Valor total
            </span>
            <span className="font-display text-xl font-extrabold text-gold" data-id="element-212">
              {VALUE_TOTAL}
            </span>
          </div>

          {/* Hoy */}
          
        </div>

        <div className="mt-12" data-id="element-213">
          <PriceBlock data-id="element-214" />
        </div>
      </SectionReveal>
    </section>;
}